<div
  [ngClass]="cssClass()"
  class="inline-flex text-sm font-bold uppercase">
  {{ selectType() | boxQuestionnaireSelectType | async }}
</div>
